import React from 'react';
import { NumericFormat } from 'react-number-format';

const CurrencyInput = ({
  disabled = false,
  label,
  name,
  value,
  onChange,
  required = false,
  py = 'py-3',
  textSize = 'text-base',
  allowNegative = false,
}) => {
  const handleValueChange = (values) => {
    const { floatValue } = values;

    onChange({
      target: {
        name,
        value: floatValue ?? 0,
      },
    });
  };

  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label htmlFor={name} className="text-lg text-blueDarker font-normal">
          {label}
          {required && <span className="ml-1.5">*</span>}
        </label>
      )}

      <NumericFormat
        id={name}
        name={name}
        required={required}
        disabled={disabled}
        value={value}
        thousandSeparator="."
        decimalSeparator=","
        prefix="R$ "
        decimalScale={2}
        fixedDecimalScale
        allowNegative={allowNegative}
        onValueChange={handleValueChange}
        className={`w-full border border-bluePale rounded-xl px-3 ${py} ${textSize} placeholder-blueSteel`}
      />
    </div>
  );
};

export default CurrencyInput;
